export default "__VITE_ASSET__85Cou$9k__"